export interface MerchantRatingInit {
  average: number;
  points: {
    one: number;
    two: number;
    three: number;
    four: number;
    five: number;
  };
  sum: number;
  totalCount: number;
}

export default class MerchantRating {
  public readonly average: number;
  public readonly points: {
    one: number;
    two: number;
    three: number;
    four: number;
    five: number;
  };
  public readonly sum: number;
  public readonly totalCount: number;

  constructor(init: MerchantRatingInit) {
    this.average = init.average;
    this.points = init.points;
    this.sum = init.sum;
    this.totalCount = init.totalCount;
  }
}
